






import { Component, Vue, Watch } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import ClaimSummarySections from "@/components/vcponlineok/claim-summary/claim-summary-sections.vue";
import { IClaimDataDto, IVcClaimDto, PagedAndSortedInputDto, IPagedAndSortedInputDto } from "@/asdcom/apiproxy/apiproxy.dto";
import ClaimViewBaseComponent from "./ClaimViewBaseComponent";

@Component({
  components: {
    ClaimSummarySections
  }
})
export default class ClaimSummary extends ClaimViewBaseComponent {
  loading: boolean = false;
  crimeTypes: any[] = [];
  //claimNumber?: string = undefined;
  viewModel: IClaimDataDto = <IClaimDataDto>{};

  async created() {
    this.loading = true;
        this.getCurrentClaim()
          .then((clm: IVcClaimDto) => {

            //abp.log.debug({ claimData: clm.claimData });
            this.viewModel = <IClaimDataDto>clm.claimData;
          })
          .finally(()=>{
            this.loading = false;
          });
    // 
    // abp.log.debug({
    //   "---- claim-summary-view": this.$route.params["claimNumber"]
    // });
    
  }
}
